import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['unseen']
    static values = { url: String }

    connect() {
        this.pendingIds = new Set()
        this.timeout = null

        this.observer = new IntersectionObserver(
            (entries) => this.handleIntersection(entries),
            { threshold: 0.5 }
        )

        this.unseenTargets.forEach((el) => this.observer.observe(el))
    }

    disconnect() {
        this.observer?.disconnect()
        if (this.timeout) clearTimeout(this.timeout)
        this.flush()
    }

    unseenTargetConnected(el) {
        this.observer?.observe(el)
    }

    unseenTargetDisconnected(el) {
        this.observer?.unobserve(el)
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const el = entry.target
                const id = el.dataset.notificationId
                if (id) this.pendingIds.add(id)

                this.observer.unobserve(el)
            }
        })

        if (this.pendingIds.size > 0) {
            if (this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(() => this.flush(), 500)
        }
    }

    flush() {
        if (this.pendingIds.size === 0) return

        const ids = [...this.pendingIds]
        this.pendingIds.clear()

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

        fetch(this.urlValue, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
                Accept: 'application/json'
            },
            body: JSON.stringify({ ids })
        }).then(() => {
            const countFrame = document.getElementById('notification_count')
            if (countFrame) countFrame.src = countFrame.src
        })
    }
}
